/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Vat_InvalidInputs */

const vi_einvoice_draft_vat_invalid = /** @type {(inputs: Einvoice_Draft_Vat_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền VAT phải là số nguyên từ 0 đồng trở lên.`)
};

/**

* @param {Einvoice_Draft_Vat_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_vat_invalid = /** @type {((inputs?: Einvoice_Draft_Vat_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Vat_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_vat_invalid(inputs)
});